<template>
  <div>
    <!-- <transition name="fade" mode="in-out"> -->
      <router-view />
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  name: "appMain"
};
</script>
